module.exports = __webpack_public_path__ + "img/baiji.002a14a0.png";